module.exports = function() {
    this.$store.dispatch(`${this.name}_CHECKBOX/clearSelected`);
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/methods/clear-checkbox-selected.js